import type { RadarSignal, RadarWorkspaceBundle } from './types';

// Legacy rows carry a warning prefix for old clients. Metadata drives new UI labels.
export function signalDisplayFact(signal: RadarSignal) {
  return signal.source?.check_status === 'unconfirmed'
    ? signal.fact.replace(/^Unconfirmed lead: /, '') : signal.fact;
}

// Only persisted, visible prose. Never send local edits, names, URLs or contact channels.
export function radarDisplayTexts(bundle: RadarWorkspaceBundle, section: 'brief' | 'discover' | 'watch' | 'act') {
  const values = new Set<string>();
  const add = (value: unknown) => {
    if (typeof value === 'string' && value && value.length <= 2400) values.add(value);
    else if (Array.isArray(value)) value.forEach(add);
  };
  const { workspace } = bundle;
  const brief = workspace.brief_status === 'needs_review'
    ? workspace.brief_hypothesis || workspace.brief : workspace.brief || workspace.brief_hypothesis;
  if (section === 'brief') {
    for (const key of ['seller_summary', 'products', 'relationship_goal', 'target_market',
      'target_account_types', 'required_capabilities', 'exclusions', 'trigger_types'] as const) add(brief?.[key]);
    add(workspace.brief_provenance?.assumptions);
  } else if (section === 'discover') {
    add(brief?.target_market);
    for (const candidate of bundle.candidates) {
      add(candidate.country); add(candidate.buyer_type); add(candidate.fit_summary); add(candidate.trigger?.summary);
      for (const source of [...candidate.fit_evidence, candidate.trigger_evidence, candidate.trigger?.evidence]) add(source?.title);
    }
  } else {
    const focus = bundle.signal_plan?.focus;
    add(focus?.summary); add(focus?.topics); add(focus?.people_focus);
    for (const watch of bundle.watches || []) {
      add(watch.company?.fit_summary);
      for (const signal of watch.signals || []) {
        add(signal.subject); add(signalDisplayFact(signal)); add(signal.interpretation);
        if (signal.source?.check_status !== 'unconfirmed') add(signal.source?.title);
      }
      for (const contact of watch.contacts || []) { add(contact.title); add(contact.role_fit); }
    }
  }
  return [...values];
}
